import { render } from "./BgMyTicketPaymentAmount.vue?vue&type=template&id=1f9d10d8&scoped=true"
import script from "./BgMyTicketPaymentAmount.vue?vue&type=script&lang=js"
export * from "./BgMyTicketPaymentAmount.vue?vue&type=script&lang=js"

import "./BgMyTicketPaymentAmount.vue?vue&type=style&index=0&id=1f9d10d8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1f9d10d8"

export default script